import script from "./master.vue?vue&type=script&setup=true&lang=js"
export * from "./master.vue?vue&type=script&setup=true&lang=js"

import "./master.vue?vue&type=style&index=0&id=5e5a78f2&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e5a78f2"]])

export default __exports__